import React from 'react';

const MainContainer: React.FC = ({ children }) => (
  <div id="main">{children}</div>
);

export default MainContainer;
